import { extendTheme } from "@chakra-ui/react"

export const theme = extendTheme({
    colors: {
        brand: {
            100: "#1D4C7E",
            500: "#1D4C7E"
        }
    }
})